<div class="cardLayout">
  <ion-row>
    <ion-col size="8">
      <div class="formLabelSemiBoldfs16 mb-5">
        {{ operation === 'Edit' ? 'Edit Competency' : 'Add Competency' }}
      </div>
    </ion-col>
    <ion-col size="4" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>


<form [formGroup]="competencyForm" (ngSubmit)="onSubmit()">
  <ion-row>
    <ion-col size="4" class="mt-10">
      <label class="formLabelRegularfs16 mb-5">
        Dept/Function<span class="red-cl">*</span>
      </label>
      <ng-select
      placeholder="Select Dept/Function"
      formControlName="selectedHrAdminFunction"
      [clearable]="false"
      (change)="onFunctionChange($event)">
      <ng-option *ngFor="let func of getListOfDepartmentsOfComp" [value]="func.id">
        {{ func.name }}
      </ng-option>
    </ng-select>
    
    </ion-col>
    <ion-col size="4" class="mt-10">
      <label class="formLabelRegularfs16 mb-5">
        {{ selectedCompetency }} <span class="red-cl">*</span>
      </label>
      <ng-select
        placeholder="Select"
        formControlName="selectedBand"
        (change)="onBandSelectionChange($event)"
        [clearable]="false"
        [required]="true">
        <ng-option *ngFor="let item of bandListHrAdmin" [value]="item.id">
          {{ item.name }}
        </ng-option>
      </ng-select>
      <mat-error *ngIf="competencyForm.get('selectedBand')?.hasError('required')">{{selectedCompetency}} is required</mat-error>
    </ion-col>
  </ion-row>

  <div formArrayName="competencies">
    <div *ngFor="let competency of competencyArray.controls; let i = index" [formGroupName]="i">
      <ion-row>
        <ion-col size="4" class="mt-10">
          <label class="formLabelRegularfs16 mb-5">
            Competency Name <span class="red-cl">*</span>
          </label>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput placeholder="Type text here" maxlength="254" class="font_regular" formControlName="competencyName">
          </mat-form-field>
        </ion-col>
        <ion-col size="4" class="mt-10">
          <label class="formLabelRegularfs16 mb-5">
            Competency Defination <span class="red-cl">*</span>
          </label>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput (input)="checkLengthOfField($event)" placeholder="Type text here" maxlength="255" class="font_regular" formControlName="competencyDefinition">
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <mat-form-field class="w-20 mat-height40 mat-input-style mt-25">
            <input type="number" matInput placeholder="Wt" class="font_regular" formControlName="weight" 
                   (input)="validateWeight($event)">
            <mat-error *ngIf="competency.get('weight')?.hasError('required')">Weight is required</mat-error>
          </mat-form-field>          
          <span class="ml-20 DeleteColor cp" *ngIf="i>0" (click)="deleteCompetency(i)">Delete</span>
          <span *ngIf="i === competencyArray.length - 1 && getTotalWeight() < maxTotalWeight && !competencyForm.get('competencies')?.hasError('duplicateCombination')"
                class="ml-20 AddNewColor cp" (click)="addCompetency()">
            + Add New
          </span>
        </ion-col>
      </ion-row>
    </div>

    <!-- Display global error message -->
    <mat-error *ngIf="competencyForm.get('competencies')?.hasError('duplicateCombination')">
      Duplicate Competency Name and Definition combination detected.
    </mat-error>
  </div>

  <div class="text-right mt-10">
    Total: {{ getTotalWeight() }}
    <button id="addButton" type="submit" class="add_btn fs-14 ml-20"
      [style.background-color]="buttonColorCode"
      [disabled]="isButtonDisabled">
      Add
    </button>
  </div>
  
</form>

  
  
  <div class="clear20"></div>
</div>
